import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const PageSkeletonAnalytics = () => {
  return (
    <Box sx={{ width: '100%', marginTop: '20px' }}>
      {/* Top Stats Section */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[...Array(4)].map((_, i) => (
          <Grid item xs={12} md={5.9} lg={2.9} key={i}>
            <Box sx={{ 
              p: 2,
              border: '1px solid #E4EBF6',
              borderRadius: '8px',
              bgcolor: 'white'
            }}>
              <Skeleton variant="text" width="60%" height={24} sx={{ bgcolor: '#E6EDF9' }} />
              <Skeleton variant="text" width="80%" height={32} sx={{ bgcolor: '#E6EDF9' }} />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Main Graph */}
      <Box sx={{ 
        p: 3,
        mb: 3,
        border: '1px solid #E4EBF6',
        borderRadius: '8px',
        bgcolor: 'white'
      }}>
        <Skeleton variant="rectangular" width="100%" height={300} sx={{ bgcolor: '#E6EDF9' }} />
      </Box>

      {/* Stats Boxes */}
      <Grid container spacing={2}>
        {[...Array(3)].map((_, i) => (
          <Grid item xs={12} key={i}>
            <Box sx={{
              p: 3,
              border: '1px solid #E4EBF6', 
              borderRadius: '8px',
              bgcolor: 'white'
            }}>
              <Skeleton variant="text" width="200px" sx={{ mx: 'auto', mb: 2, bgcolor: '#E6EDF9' }} />
              <Grid container spacing={2} justifyContent="space-between">
                {[...Array(4)].map((_, j) => (
                  <Grid item xs={3} key={j}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Skeleton variant="text" width="80%" sx={{ mx: 'auto', bgcolor: '#E6EDF9' }} />
                      <Skeleton variant="text" width="60%" sx={{ mx: 'auto', bgcolor: '#E6EDF9' }} />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Charts Section */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[...Array(3)].map((_, i) => (
          <Grid item xs={12} sm={5.9} md={3.9} key={i}>
            <Box sx={{
              p: 3,
              border: '1px solid #E4EBF6',
              borderRadius: '8px',
              bgcolor: 'white',
              minHeight: '300px'
            }}>
              <Skeleton variant="text" width="200px" sx={{ mx: 'auto', mb: 2, bgcolor: '#E6EDF9' }} />
              <Skeleton variant="circular" width={200} height={200} sx={{ mx: 'auto', bgcolor: '#E6EDF9' }} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PageSkeletonAnalytics;
